import { Component, Input, OnInit } from '@angular/core';
import { GlobalConstants } from '../../../../functions/src/shared/global-constants';
import { SettingService } from 'src/common/services/setting/setting.service';
import { CallRequestService } from 'src/common/services/call-request/call-request.service';

@Component({
  selector: 'new-request-card',
  templateUrl: './new-request-card.component.html',
  styleUrls: ['./new-request-card.component.scss']
})
export class NewRequestCardComponent implements OnInit {

  public GLOBAL = new GlobalConstants();
  public callRequested = false;

  @Input()
  values: any;

  constructor(
    public setting: SettingService,
    private callRequest: CallRequestService,
  ) { }

  ngOnInit(): void {
  }

  // Normalize unitTypes so template can iterate safely
  get unitTypes(): string[] {
    const value = this.values?.data?.unitTypes;
    if (!value) return [];
    if (Array.isArray(value)) return value;
    if (typeof value === 'string') {
      return value.split(',').map(v => v.trim()).filter(Boolean);
    }
    return [];
  }

  getTelLink(tel: string): string {
    if (!tel) return '';
    const normalized = tel.replace(/[^\d+]/g, '');
    return normalized ? `tel:${normalized}` : '';
  }

  requestPhoneCall(phone: string, name?: string): void {
    if (this.callRequested) {
      return;
    }
    this.callRequested = true;
    this.callRequest.createCallRequest(phone, name, window.location.pathname);
    setTimeout(() => {
      this.callRequested = false;
    }, 5000);
  }

  getContactDisplayName(data: any): string {
    if (!data) return '';
    if (data.fullname) return data.fullname;
    const title = this.setting.getParamValue('titles', data.title)?.label || '';
    const firstname = data.firstname || '';
    const lastname = data.lastname || '';
    return `${title ? title + ' ' : ''}${firstname} ${lastname}`.trim();
  }

}
